import { Icon } from './Icon';

interface ReferralInviteModalProps {
  inviterName: string;
  onClose: () => void;
}

export function ReferralInviteModal({ inviterName, onClose }: ReferralInviteModalProps): JSX.Element {
  return (
    <div className="modal-backdrop referral-invite-backdrop" role="presentation">
      <section className="referral-invite" role="dialog" aria-modal="true" aria-labelledby="referral-invite-title">
        <span className="referral-invite__spark referral-invite__spark--one" />
        <span className="referral-invite__spark referral-invite__spark--two" />
        <div className="referral-invite__badge"><Icon name="spark" /></div>
        <span className="eyebrow eyebrow--glow">CONVITE DESBLOQUEADO</span>
        <h2 id="referral-invite-title">Você foi convidado por <strong>{inviterName}</strong>.</h2>
        <p>A galera está formando a próxima madrugada. Seu passe começa por aqui.</p>
        <button type="button" className="button button--primary button--full" onClick={onClose}>Aceitar o convite<Icon name="arrow-right" /></button>
      </section>
    </div>
  );
}
